export const levenshtein = (a: string, b: string): number => {
  const m: number[][] = [];
  for (let i = 0; i <= b.length; i++) {
    m[i] = [i];
  }
  for (let j = 0; j <= a.length; j++) {
    m[0]![j] = j;
  }
  for (let i = 1; i <= b.length; i++) {
    for (let j = 1; j <= a.length; j++) {
      m[i]![j] = b[i - 1] === a[j - 1]
        ? m[i - 1]![j - 1]!
        : 1 + Math.min(m[i - 1]![j - 1]!, m[i]![j - 1]!, m[i - 1]![j]!);
    }
  }
  return m[b.length]![a.length]!;
};

/**
 * Returns the candidate string most similar to `target`, provided its
 * Levenshtein distance is <= 2. Case-insensitive exact match wins outright
 * (and the original-cased candidate is returned).
 *
 * Returns null when no candidate is within the distance threshold.
 */
export const findSimilarString = (target: string, candidates: readonly string[]): string | null => {
  const lower = target.toLowerCase();
  const exact = candidates.find(c => c.toLowerCase() === lower);
  if (exact) {
    return exact;
  }

  let best: string | null = null;
  let bestDist = Infinity;
  for (const c of candidates) {
    const d = levenshtein(lower, c.toLowerCase());
    if (d < bestDist && d <= 2) {
      bestDist = d;
      best = c;
    }
  }
  return best;
};
